<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>仓库名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入仓库名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>托运类型：</p>
        <el-select v-model="areaIpt" filterable size="mini" style="width:150px" placeholder="请选择托运类型">
          <el-option v-for="item in areaOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 260px">
        <p>托运商/船舶名：</p>
        <el-input v-model="shipNameIpt" size="mini" style="width:150px" placeholder="请输入托运商/船舶名称"/>
      </div>
      <div class="navContainer" style="width: 260px">
        <p>司机/船长姓名：</p>
        <el-input v-model="driverNameIpt" size="mini" style="width:150px" placeholder="请输入司机/船长姓名"/>
      </div>
      <div class="navContainer" style="width: 260px">
        <p>车牌号/出航号：</p>
        <el-input v-model="carIpt" size="mini" style="width:150px" placeholder="请输入车牌号/出航号"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运单编号：</p>
        <el-input v-model="willbillIpt" size="mini" style="width:150px" placeholder="请输入运单编号"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>批次号：</p>
        <el-input v-model="batchIpt" size="mini" style="width:150px" placeholder="请输入批次号"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>车架号：</p>
        <el-input v-model="frameIpt" size="mini" style="width:150px" placeholder="请输入车架号"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>交车类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width:150px" placeholder="请选择交车类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 480px">
        <p>出库时间：</p>
        <el-date-picker
          v-model="time"
          size="mini"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="name" label="仓库名称" align="center"/>
          <el-table-column prop="area" label="托运类型" align="center"/>
          <el-table-column prop="shipName" label="托运商/船舶名" align="center"/>
          <el-table-column prop="driverName" label="司机/船长姓名" align="center"/>
          <el-table-column prop="car" label="车牌号/出航号" align="center"/>
          <el-table-column prop="waybill" label="运单编号" align="center"/>
          <el-table-column prop="batch" label="批次号" align="center"/>
          <el-table-column prop="frame" label="车架号" align="center"/>
          <el-table-column prop="type" label="交车类型" align="center"/>
          <el-table-column prop="person" label="扫码人" align="center"/>
          <el-table-column prop="time" label="出库时间" align="center"/>
          <el-table-column prop="address" label="扫码地址" align="center"/>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      nameIpt:'',
      areaIpt:0,
      typeIpt:0,
      shipNameIpt:'',
      driverNameIpt:'',
      willbillIpt:'',
      batchIpt:'',
      carIpt:'',
      frameIpt:'',
      time:'',
      areaOption:[
        {value:0,label:'全部',},
        {value:'车队',label:'车队'},
        {value:'船舶',label:'船舶'},
      ],
      typeOption:[
        {value:0,label:'全部',},
        {value:'扫码交车',label:'扫码交车'},
        {value:'批量导入',label:'批量导入'},
        {value:'手动交车',label:'手动交车'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[
        {name:'仓库1',area:'车队',shipName:'车队1',driverName:'张三',car:'渝A02120',waybill:'YD251245122',batch:'PC202121221',parking:'D区20121',type:'扫码交车',person:'周世鹏',frame:'CJ52154121',time:'2021-10-9 15:55:55',address:'重庆市xxx\n',},
        {name:'仓库1',area:'船舶',shipName:'船舶1',driverName:'李四',car:'202121201E',waybill:'YD251245122',batch:'PC202121221',parking:'D区545121',type:'批量导入',person:'周世鹏',frame:'CJ52154121',time:'2021-10-9 15:55:55',address:'重庆市xxx\n',},
        {name:'仓库1',area:'车队',shipName:'车队1',driverName:'王五',car:'渝A02120',waybill:'YD251245122',batch:'PC202121221',parking:'A区212542',type:'手动交车',person:'周世鹏',frame:'CJ52154121',time:'2021-10-9 15:55:55',address:'重庆市xxx\n',},
      ],
    };
  },
  methods: {
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    searchBtn(){
      this.page = 1;
    },
    resetBtn(){
      this.time='';
      this.frameIpt='';
      this.carIpt='';
      this.nameIpt='';
      this.willbillIpt='';
      this.batchIpt='';
      this.shipNameIpt='';
      this.driverNameIpt='';
      this.areaIpt=0;
      this.typeIpt=0;
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    .unitContainer{
      display: flex;
      align-items:center;
      justify-content:space-between;
      width:140px;
      margin-bottom:5px;
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    .unitContainer2{
      display: flex;
      align-items:center;
      justify-content:space-between;
      width:189px;
      margin-bottom:5px;
      span{
        color: #606266;
        font-weight: 700;
      }
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
